import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as stationSearchActions from '../stationSearch/stationSearchActions';
import * as productSearchActions from './productSearchActions';
import StationSearchContainer from '../stationSearch/StationSearchContainer';
import {PSEUDO_CITY} from '../productSearch/stationTypeConstants';
import i18n from 'i18next';
import translations from "../translations";

i18n.init({
  lng: window.Flyblade.locale,
  resources: translations
});

class DestinationSearchContainer extends Component {

  constructor(props) {
    super(props);
    this.onCancelSearchClick = this.onCancelSearchClick.bind(this);
    this.searchStations = _.debounce(this.searchStations.bind(this), 300);
    this.selectResultAndClose = this.selectResultAndClose.bind(this);
  }

  componentDidMount() {
    $('#key-routes').hide();
    this.executeSearch('');
  }

  searchStations(event) {
    this.executeSearch(event.target.value);
  }

  executeSearch(query) {
    this.props.actions.searchDestinations(query, true, this.props.suggested_stations, this.props.origin_selections);
  }

  selectResultAndClose(station_result) {
    $('#key-routes').show();
    this.props.actions.selectDestinations(station_result);
    this.back();
  }

  onCancelSearchClick() {
    if (this.props.hideOnCancel){
      $('#productSearch').hide();
    } else {
      $('#key-routes').show();
      this.back();
    }
  }

  back() {
    this.props.actions['open' + this.props.back]();
  }

  buildWithScheduledServiceHeader() {
    let result = this.props.origin_station_result;
    if (result) return 'Scheduled, Charter, Crowdsource from ' + result.code;
  }

  buildSuggestedHeader() {
    let result = this.props.origin_station_result;
    if (result) {
      return i18n.t('destinationSearch.suggestedCharter') + result.code;
    } else {
      return i18n.t('destinationSearch.suggested')
    }
  }

  getOppositeDirectionCode() {
    let result = this.props.origin_station_result;
    if (result) return result.code;
  }

  render() {
    return (
      <StationSearchContainer
        label={i18n.t('destinationSearch.label')}
        searchStations={this.searchStations}
        cancelSearch={this.onCancelSearchClick}
        selectStationResult={this.selectResultAndClose}
        oppositeDirectionCode={this.getOppositeDirectionCode()}
        suggested={{showPopular: true}}
        placeholder={i18n.t('destinationSearch.placeholder')}
        withScheduledServiceHeader={this.buildWithScheduledServiceHeader()}
        suggestedHeader={this.buildSuggestedHeader()}
        pointDescription={i18n.t('destinationSearch.destinations')}
      />
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    hideOnCancel: state.productSearch.destination_search_container.hideOnCancel,
    back: state.productSearch.destination_search_container.back,
    suggested_stations: state.productSearch.suggested_stations,
    origin_selections: state.productSearch.origin_selections,
    origin_station_result: state.productSearch.origin_station_result
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({...stationSearchActions, ...productSearchActions}, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DestinationSearchContainer)
